import { Button, Grid, Box, IconButton, Stack, Typography, Radio, TextField as MuiTextField } from '@mui/material';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, request, toast } from '../../../../../utils';

export const BloodRequestAddDetailsForm = ({
  onClose,
  onAdd,
  bloodGroupDropdown,
  componentDropdown,
  setBloodIntakeData,
  bloodIntakeData
}) => {
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        component: Yup.string().required('Please select Doctor'),
        blood_group: Yup.string().required('Please select Service')
      })
    ),
    defaultValues: {
      quantity: 1,
      rate: 0,
      amount: 0
    },
    mode: 'all'
  });
  const { reset } = methods;

  const { handleSubmit, setValue, watch } = methods;

  const formSubmitHandler = (formValues) => {
    if (formValues.stock_available >= formValues?.quantity) {
      formValues.gst_per = +formValues.gst_per;
      formValues.disc_per = +formValues.disc_per;
      formValues.quantity = +formValues.quantity;
      const transformedValues = {
        ...formValues,
        amount: formValues?.rate * quantityWatch
      };
      onAdd(transformedValues);
    } else {
      toast('Insufficient Stock', { variant: 'warning' });
    }
  };

  const rateWatch = watch('rate');
  const quantityWatch = watch('quantity');
  const discPerWatch = watch('disc_per');
  const gstPerWatch = watch('gst_per');
  const discAmtWatch = watch('disc_amt');

  useEffect(() => {
    const amount = rateWatch * quantityWatch;
    const discAmt = parseFloat(((amount * discPerWatch) / 100).toFixed(2));
    const gstAmt = parseFloat((((amount - discAmt) * gstPerWatch) / 100).toFixed(2));
    const netAmt = parseFloat((amount - discAmt + gstAmt).toFixed(2));
    setValue('amount', parseFloat(amount.toFixed(2)));
    setValue('disc_amt', discAmt);
    setValue('gst_amt', gstAmt);
    setValue('net_amt', netAmt);
  }, [rateWatch, quantityWatch, discPerWatch, gstPerWatch, setValue]);

  useEffect(() => {
    if (rateWatch && quantityWatch && discAmtWatch !== undefined) {
      const amount = rateWatch * quantityWatch;
      const newDiscPer = parseFloat(((discAmtWatch / amount) * 100).toFixed(6));
      setValue('disc_per', newDiscPer);
    }
  }, [rateWatch, quantityWatch, discAmtWatch, setValue]);

  const componentId = watch('component');
  const bloodGroupId = watch('blood_group');

  useEffect(() => {
    if (componentId && bloodGroupId) {
      const filteredData = bloodIntakeData.filter(
        (item) => item.component === componentId && item.bloodGroup === bloodGroupId
      );

      const totalStock = filteredData.reduce((acc, item) => acc + item.totalQuantity, 0);

      setValue('stock_available', totalStock);
    }
  }, [componentId, bloodGroupId, bloodIntakeData, setValue]);

  return (
    <Stack spacing={1} sx={{ height: '100%' }}>
      <Stack direction="row" spacing={0} alignItems="center" justifyContent="space-between" borderColor="grey.300">
        <Typography variant="h4" fontWeight="bold">
          Add Blood Intake Details
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>
      <FormProvider
        sx={{ height: '100%', overflow: 'auto' }}
        methods={methods}
        onSubmit={handleSubmit(formSubmitHandler)}
      >
        <Grid container spacing={1} sx={{ flex: 1, height: '100%', overflow: 'auto' }}>
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.2, px: 2 }}>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Component Name</Typography>
                <SelectTag
                  menus={componentDropdown.map((data) => ({ ...data, name: data?.component }))}
                  formControlSX={{ flex: 0.8 }}
                  name="component"
                  placeholder="Enter Component Name"
                />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Blood Group</Typography>
                <SelectTag
                  menus={bloodGroupDropdown.map((data) => ({ ...data, name: data?.group }))}
                  formControlSX={{ flex: 0.8 }}
                  name="blood_group"
                  placeholder="Select Blood Group"
                />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Stock Available</Typography>
                <TextField sx={{ flex: 0.8 }} name="stock_available" placeholder="Total Stock Available" disabled />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Quantity</Typography>
                <TextField
                  sx={{ flex: 0.8 }}
                  type="number"
                  inputProps={{ min: '0' }}
                  name="quantity"
                  placeholder="Quantity"
                />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end" sx={{ marginTop: '2%' }}>
                <Button variant="contained" type="submit">
                  Add
                </Button>
                <Button variant="outlined" onClick={onClose} color="error">
                  Close
                </Button>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </FormProvider>
    </Stack>
  );
};
